export default __webpack_public_path__ + "static/assets/med_capsule_V_semi_01_b_mask.6a26c320.png";